import React, { ReactNode } from "react"

import { getLocale, getSupportedLocale } from "@/core/utils/get-supported-locale"
import { getUserLocaleFromBrowser } from "@/core/utils/get-supported-locale/get-user-locale"
import { LocaleType } from "@/core/utils/get-supported-locale/types"

import { defaultLocale, knownLocales } from "../utils/constant"

type ConfigContextProps = { locale: LocaleType | null }
type ConfigProps = {
  children: ReactNode
}

export const ConfigContext = React.createContext<ConfigContextProps>({ locale: null })

export const ConfigProvider = ({ children }: ConfigProps) => {
  const searchParams = new URLSearchParams(window.location.search)
  const country = searchParams.get("country")
  const searchParamLocale = knownLocales.find(
    (supportedLocale) => supportedLocale.territory === country?.toUpperCase(),
  )
  const browserLocale = getSupportedLocale(
    getLocale(getUserLocaleFromBrowser(), knownLocales),
    knownLocales,
    defaultLocale,
  )
  const merchantLocale = searchParamLocale ?? browserLocale
  return (
    <ConfigContext.Provider value={{ locale: merchantLocale }}>
      {children}
    </ConfigContext.Provider>
  )
}
